import React, { useState, useEffect } from 'react';
import HeroLanding from '../components/HeroLanding';
import AboutSection from '../components/AboutSection';
import AnimatedSection from '../components/AnimatedSection';
import ProductCarousel from '../components/ProductCarousel';
import { useLanguage, t } from '../utils/i18n';
import client from '../utils/sanityClient';
import Categories from '../components/Categories';

const HomePage = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const { language } = useLanguage();
  
  useEffect(() => {
    const loadProducts = async () => {
      try {
        console.log('Fetching products from Sanity...');
        const sanityProducts = await client.fetch(`
          *[_type == "product"] { 
            _id,
            name,
            price,
            description,
            images[]{ 
              _key,
              alt,
              principal,
              asset->{
                _id,
                url 
              }
            }
          }
        `);
        
        const mappedProducts = sanityProducts.map(product => {
          const mainImage = product.images?.find(img => img.principal) || product.images?.[0];
          return {
            id: product._id,
            name: product.name,
            image: mainImage?.asset?.url || '/assets/icons/placeholder.png',
            price: product.price || 0,
            material: product.description || 'Material no especificado',
            _original: product 
          };
        });

        const featured = [...mappedProducts]
          .sort(() => 0.5 - Math.random())
          .slice(0, 4);
        setFeaturedProducts(featured);

      } catch (error) {
        console.error('Failed to load products from Sanity:', error);
      }
    };
    
    loadProducts();
  }, []);

  return (
    <div className="relative bg-akasha-light-beige">
      <div className="absolute inset-0 bg-gradient-to-b from-[#F2EBE6] to-[#D5BCA3] z-0" />
      <div className="relative z-10">
        <HeroLanding 
          title="Akasha Concept Store"
          subtitle={t('home.hero.subtitle', language.code)}
          buttonText={t('home.hero.cta', language.code)}
          buttonLink="/catalog"
        />
        <Categories />
      </div>

      {/* Separator */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-neutral-800 to-transparent opacity-50" />

      {/* Featured Products Section */}
      {featuredProducts.length > 0 && (
        <ProductCarousel 
          products={featuredProducts} 
          title={t('home.featured.title', language.code)} 
        />
      )}

      {/* Separator */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-neutral-800 to-transparent opacity-50" />

      {/* About Section */}
      <AnimatedSection delay={0.2}>
        <AboutSection 
          title={t('home.about.title', language.code)}
          content={
            <div>
              <p className="mb-4">
                {language.code === 'es' ? 
                  'Akasha Concept Store nace de la pasión por los materiales naturales y el diseño artesanal. Cada pieza en nuestra colección cuenta una historia de tradición, calidad y respeto por la naturaleza.' : 
                  'Akasha Concept Store is born from a passion for natural materials and artisanal design. Each piece in our collection tells a story of tradition, quality, and respect for nature.'}
              </p>
              <p>
                {language.code === 'es' ? 
                  'Trabajamos con artesanos locales para ofrecerte muebles y decoración que combinan diseño contemporáneo con técnicas tradicionales, creando espacios únicos que reflejan la nobleza de los materiales naturales.' : 
                  'We work with local artisans to offer you furniture and decor that combine contemporary design with traditional techniques, creating unique spaces that reflect the nobility of natural materials.'}
              </p>
            </div>
          }
          image="/assets/products/Jarrones CARA negro.jpg"
          imageAlt="Jarrones Cara Negro - Akasha Concept Store"
        />
      </AnimatedSection>

      {/* Separator */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-neutral-800 to-transparent opacity-50" />
    </div>
  );
};

export default HomePage;
